import { render, staticRenderFns } from "./modal-address.vue?vue&type=template&id=6caf8ef6&"
import script from "./modal-address.vue?vue&type=script&lang=js&"
export * from "./modal-address.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports